import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$
export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('GasstationRule-index-1992f2b7d5b2aa20c-1'),
    routerUrl: '/GasstationRule',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./GasstationRule')),
    children: [],
  },
];
